import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils/DateUtils";
import { UserSubscription } from "./types";
import { getIntervalLabel, paymentSymbol } from "./utils";
import SubscriptionInfo from "./components/subscription-info";

interface Props {
    subscription: UserSubscription;
    timezone?: string;
}

export default function SubscriptionDetail({ subscription, timezone }: Props) {
    const { t } = useTranslation();
    const isAutoRenew =
        subscription.status === "active" && subscription.auto_renew;

    return (
        <div className="subscription-details">
            <SubscriptionInfo
                label={t("subscriptions.sub_status")}
                value={t(subscription.status)}
                status={subscription.status}
                data-attr-id="subscription-status"
            />

            <SubscriptionInfo
                label={t("subscriptions.plan")}
                value={`${getIntervalLabel(
                    subscription?.payment_plan?.interval
                )} (${paymentSymbol[subscription.currency]}${
                    subscription.amount
                })`}
                data-attr-id="subscription-plan"
            />

            <SubscriptionInfo
                label={t("subscriptions.currency")}
                value={subscription.currency}
                data-attr-id="subscription-currency"
            />

            <SubscriptionInfo
                label={t("subscriptions.start_date")}
                value={formatDate(subscription.starts_at, "LL", timezone)}
                data-attr-id="subscription-start-date"
            />

            {isAutoRenew && (
                <SubscriptionInfo
                    label={t("subscriptions.next_billing_date")}
                    value={formatDate(subscription.ends_at, "LL", timezone)}
                    data-attr-id="subscription-next-billing-date"
                />
            )}

            <SubscriptionInfo
                label={t("subscriptions.auto_renew")}
                value={isAutoRenew ? t("Yes") : t("No")}
                data-attr-id="subscription-auto-renewal"
            />

            <SubscriptionInfo
                label={t("subscriptions.payment_method")}
                value={subscription.provider}
                data-attr-id="subscription-payment-method"
            />
        </div>
    );
}
